import { useEffect, useRef } from "react";
import { IntersectionOptions, useInView } from "react-intersection-observer";

export const useHasComeIntoView = (options: IntersectionOptions) => {
  const prevInViewValue = useRef<boolean | undefined>(undefined);
  const { ref, inView } = useInView(options);

  useEffect(function storePreviousInViewState() {
    prevInViewValue.current = inView;
  });

  const hasComeIntoView = inView && !prevInViewValue.current;

  return { ref, hasComeIntoView };
};
